import marotteCheneAureaMT201Scale from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-01-Scale.jpg"
import marotteCheneAureaMT201Panel from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-01-Panel.jpg"

import marotteCheneAureaMT203Scale from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-03-Scale.jpg"
import marotteCheneAureaMT203Panel from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-03-Panel.jpg"

import marotteCheneAureaMT214Scale from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-14-Scale.jpg"
import marotteCheneAureaMT214Panel from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-14-Panel.jpg"

import marotteCheneAureaMT215Scale from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-15-Scale.jpg"
import marotteCheneAureaMT215Panel from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-15-Panel.jpg"

import marotteCheneAureaMT222Scale from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-22-Scale.jpg"
import marotteCheneAureaMT222Panel from "../images/surfaces/variants/Marotte_Chene_aurea_MT2-22-Panel.jpg"

//import marotteEbenereconstitueMR1913Scale from "../images/surfaces/variants/.jpg"
//import marotteEbenereconstitueMR1913Panel from "../images/surfaces/variants/.jpg"

import marotteFreneExcelsiorMT409Scale from "../images/surfaces/variants/Marotte_Frene_Excelsior_MT4-09-Scale.jpg"
import marotteFreneExcelsiorMT409Panel from "../images/surfaces/variants/Marotte_Frene_Excelsior_MT4-09-Panel.jpg"

//import marotteFreneExcelsiorMT426Scale from "../images/surfaces/variants/Marotte_Frene_Excelsior_MT4-26-Scale.jpg"
//import marotteFreneExcelsiorMT426Panel from "../images/surfaces/variants/Marotte_Frene_Excelsior_MT4-26-Panel.jpg"

import marotteLatiMT10019Scale from "../images/surfaces/variants/Marotte_Lati_MT100-19-Scale.jpg"
import marotteLatiMT10019Panel from "../images/surfaces/variants/Marotte_Lati_MT100-19-Panel.jpg"

import marotteNoyerUSSepiumMT1210Scale from "../images/surfaces/variants/Marotte_Noyer_Sepium_MT12-10-Scale.jpg"
import marotteNoyerUSSepiumMT1210Panel from "../images/surfaces/variants/Marotte_Noyer_Sepium_MT12-10-Panel.jpg"

import marotteNoyerUSSepiumMT1222Scale from "../images/surfaces/variants/Marotte_Noyer_Sepium_MT12-22-Scale.jpg"
import marotteNoyerUSSepiumMT1222Panel from "../images/surfaces/variants/Marotte_Noyer_Sepium_MT12-22-Panel.jpg"

//import marotteSapelliBoyoMT275T17Scale from "../images/surfaces/variants/.jpg"
//import marotteSapelliBoyoMT275T17Panel from "../images/surfaces/variants/.jpg"

import marotteTulipierEndronMT10825Scale from "../images/surfaces/variants/Marotte_Tulipier_Endron_MT108-25-Scale.jpg"
import marotteTulipierEndronMT10825Panel from "../images/surfaces/variants/Marotte_Tulipier_Endron_MT108-25-Panel.jpg"


import oberflexacajouafriquet19Panel  from "../images/surfaces/variants/oberflex-acajouafriquet19-1200x2490.jpg"
import oberflexacajouafriquet19Scale  from "../images/surfaces/variants/oberflex-acajouafriquet19-2560x1440.jpg"
import oberflexacajout17Panel  from "../images/surfaces/variants/oberflex-acajout17-1200x2490.jpg"
import oberflexacajout17Scale  from "../images/surfaces/variants/oberflex-acajout17-2560x1440.jpg"
import oberflexacajout19Panel  from "../images/surfaces/variants/oberflex-acajout19-1200x2490.jpg"
import oberflexacajout19Scale  from "../images/surfaces/variants/oberflex-acajout19-2560x1440.jpg"
import oberflexakoPanel  from "../images/surfaces/variants/oberflex-ako-1200x2490.jpg"
import oberflexakoScale  from "../images/surfaces/variants/oberflex-ako-2560x1440.jpg"
import oberflexaniegrePanel  from "../images/surfaces/variants/oberflex-aniegre-1200x2490.jpg"
import oberflexaniegreScale  from "../images/surfaces/variants/oberflex-aniegre-2560x1440.jpg"
import oberflexaniegret6Panel  from "../images/surfaces/variants/oberflex-aniegret6-1200x2490.jpg"
import oberflexaniegret6Scale  from "../images/surfaces/variants/oberflex-aniegret6-2560x1440.jpg"
import oberflexaniegret7Panel  from "../images/surfaces/variants/oberflex-aniegret7-1200x2490.jpg"
import oberflexaniegret7Scale  from "../images/surfaces/variants/oberflex-aniegret7-2560x1440.jpg"
import oberflexaniegret461Panel  from "../images/surfaces/variants/oberflex-aniegret461-1200x2490.jpg"
import oberflexaniegret461Scale  from "../images/surfaces/variants/oberflex-aniegret461-2560x1440.jpg"
import oberflexaulnePanel  from "../images/surfaces/variants/oberflex-aulne-1200x2490.jpg"
import oberflexaulneScale  from "../images/surfaces/variants/oberflex-aulne-2560x1440.jpg"
//import oberflexbambouPanel  from "../images/surfaces/variants/oberflex-bambou-1200x2490.jpg"
//import oberflexbambouScale  from "../images/surfaces/variants/oberflex-bambou-2560x1440.jpg"
import oberflexbamboufinnaturelPanel  from "../images/surfaces/variants/oberflex-bamboufinnaturel-1200x2490.jpg"
import oberflexbamboufinnaturelScale  from "../images/surfaces/variants/oberflex-bamboufinnaturel-2560x1440.jpg"
import oberflexbamboufinambrePanel  from "../images/surfaces/variants/oberflex-bamboufinambre-1200x2490.jpg"
import oberflexbamboufinambreScale  from "../images/surfaces/variants/oberflex-bamboufinambre-2560x1440.jpg"
//import oberflexbouleaucanadienPanel  from "../images/surfaces/variants/oberflex-bouleaucanadien-1200x2490.jpg"
//import oberflexbouleaucanadienScale  from "../images/surfaces/variants/oberflex-bouleaucanadien-2560x1440.jpg"
//import oberflexchataignierPanel  from "../images/surfaces/variants/oberflex-chataignier-1200x2490.jpg"
//import oberflexchataignierScale  from "../images/surfaces/variants/oberflex-chataignier-2560x1440.jpg"
import oberflexchenecerusePanel  from "../images/surfaces/variants/oberflex-cheneceruse-1200x2490.jpg"
import oberflexcheneceruseScale  from "../images/surfaces/variants/oberflex-cheneceruse-2560x1440.jpg"
//import oberflexcheneclairPanel  from "../images/surfaces/variants/oberflex-cheneclair-1200x2490.jpg"
//import oberflexcheneclairScale  from "../images/surfaces/variants/oberflex-cheneclair-2560x1440.jpg"
import oberflexchenenaturelPanel  from "../images/surfaces/variants/oberflex-chenenaturel-1200x2490.jpg"
import oberflexchenenaturelScale  from "../images/surfaces/variants/oberflex-chenenaturel-2560x1440.jpg"
import oberflexchenet3Panel  from "../images/surfaces/variants/oberflex-chenet3-1200x2490.jpg"
import oberflexchenet3Scale  from "../images/surfaces/variants/oberflex-chenet3-2560x1440.jpg"
//import oberflexchenet4Panel  from "../images/surfaces/variants/oberflex-chenet4-1200x2490.jpg"
//import oberflexchenet4Scale  from "../images/surfaces/variants/oberflex-chenet4-2560x1440.jpg"
//import oberflexchenet13Panel  from "../images/surfaces/variants/oberflex-chenet13-1200x2490.jpg"
//import oberflexchenet13Scale  from "../images/surfaces/variants/oberflex-chenet13-2560x1440.jpg"
//import oberflexcheneastrakanblancPanel  from "../images/surfaces/variants/oberflex-cheneastrakanblanc-1200x2490.jpg"
//import oberflexcheneastrakanblancScale  from "../images/surfaces/variants/oberflex-cheneastrakanblanc-2560x1440.jpg"
import oberflexcheneastrakannoirPanel  from "../images/surfaces/variants/oberflex-cheneastrakannoir-1200x2490.jpg"
import oberflexcheneastrakannoirScale  from "../images/surfaces/variants/oberflex-cheneastrakannoir-2560x1440.jpg"
import oberflexcheneanoeudsPanel  from "../images/surfaces/variants/oberflex-cheneanoeuds-1200x2490.jpg"
import oberflexcheneanoeudsScale  from "../images/surfaces/variants/oberflex-cheneanoeuds-2560x1440.jpg"
import oberflexcheneardoiset308Panel  from "../images/surfaces/variants/oberflex-cheneardoiset308-1200x2490.jpg"
import oberflexcheneardoiset308Scale  from "../images/surfaces/variants/oberflex-cheneardoiset308-2560x1440.jpg"
//import oberflexchenegriset309Panel  from "../images/surfaces/variants/oberflex-chenegriset309-1200x2490.jpg"
//import oberflexchenegriset309Scale  from "../images/surfaces/variants/oberflex-chenegriset309-2560x1440.jpg"
//import oberflexchenecendret310Panel  from "../images/surfaces/variants/oberflex-chenecendret310-1200x2490.jpg"
//import oberflexchenecendret310Scale  from "../images/surfaces/variants/oberflex-chenecendret310-2560x1440.jpg"
//import oberflexcheneflottet311Panel  from "../images/surfaces/variants/oberflex-cheneflottet311-1200x2490.jpg"
//import oberflexcheneflottet311Scale  from "../images/surfaces/variants/oberflex-cheneflottet311-2560x1440.jpg"
import oberflexchenevieillit312Panel  from "../images/surfaces/variants/oberflex-chenevieillit312-1200x2490.jpg"
import oberflexchenevieillit312Scale  from "../images/surfaces/variants/oberflex-chenevieillit312-2560x1440.jpg"
//import oberflexchenesauget326Panel  from "../images/surfaces/variants/oberflex-chenesauget326-1200x2490.jpg"
//import oberflexchenesauget326Scale  from "../images/surfaces/variants/oberflex-chenesauget326-2560x1440.jpg"
//import oberflexchenegrispastelt327Panel  from "../images/surfaces/variants/oberflex-chenegrispastelt327-1200x2490.jpg"
//import oberflexchenegrispastelt327Scale  from "../images/surfaces/variants/oberflex-chenegrispastelt327-2560x1440.jpg"
//import oberflexchenegreget328Panel  from "../images/surfaces/variants/oberflex-chenegreget328-1200x2490.jpg"
//import oberflexchenegreget328Scale  from "../images/surfaces/variants/oberflex-chenegreget328-2560x1440.jpg"
//import oberflexcheneblanchit329Panel  from "../images/surfaces/variants/oberflex-cheneblanchit329-1200x2490.jpg"
//import oberflexcheneblanchit329Scale  from "../images/surfaces/variants/oberflex-cheneblanchit329-2560x1440.jpg"
//import oberflexchenegraphitet330Panel  from "../images/surfaces/variants/oberflex-chenegraphitet330-1200x2490.jpg"
//import oberflexchenegraphitet330Scale  from "../images/surfaces/variants/oberflex-chenegraphitet330-2560x1440.jpg"
import oberflexcheneteintechenedesmaraisPanel  from "../images/surfaces/variants/oberflex-cheneteintechenedesmarais-1200x2490.jpg"
import oberflexcheneteintechenedesmaraisScale  from "../images/surfaces/variants/oberflex-cheneteintechenedesmarais-2560x1440.jpg"
//import oberflexcheneteintewengePanel  from "../images/surfaces/variants/oberflex-cheneteintewenge-1200x2490.jpg"
//import oberflexcheneteintewengeScale  from "../images/surfaces/variants/oberflex-cheneteintewenge-2560x1440.jpg"
import oberflexebènedesphilippinesPanel  from "../images/surfaces/variants/oberflex-ebenedesphilippines-1200x2490.jpg"
import oberflexebènedesphilippinesScale  from "../images/surfaces/variants/oberflex-ebenedesphilippines-2560x1440.jpg"
import oberflexerablecanadienPanel  from "../images/surfaces/variants/oberflex-erablecanadien-1200x2490.jpg"
import oberflexerablecanadienScale  from "../images/surfaces/variants/oberflex-erablecanadien-2560x1440.jpg"
//import oberflexerablemouchetePanel  from "../images/surfaces/variants/oberflex-erablemouchete-1200x2490.jpg"
//import oberflexerablemoucheteScale  from "../images/surfaces/variants/oberflex-erablemouchete-2560x1440.jpg"
import oberflexeucalyptusPanel  from "../images/surfaces/variants/oberflex-eucalyptus-1200x2490.jpg"
import oberflexeucalyptusScale  from "../images/surfaces/variants/oberflex-eucalyptus-2560x1440.jpg"
import oberflexeucalyptust326Panel  from "../images/surfaces/variants/oberflex-eucalyptust326-1200x2490.jpg"
import oberflexeucalyptust326Scale  from "../images/surfaces/variants/oberflex-eucalyptust326-2560x1440.jpg"
import oberflexeucalyptust311Panel  from "../images/surfaces/variants/oberflex-eucalyptust311-1200x2490.jpg"
import oberflexeucalyptust311Scale  from "../images/surfaces/variants/oberflex-eucalyptust311-2560x1440.jpg"
import oberflexeucalyptust6Panel  from "../images/surfaces/variants/oberflex-eucalyptust6-1200x2490.jpg"
import oberflexeucalyptust6Scale  from "../images/surfaces/variants/oberflex-eucalyptust6-2560x1440.jpg"
import oberflexeucalyptust331Panel  from "../images/surfaces/variants/oberflex-eucalyptust331-1200x2490.jpg"
import oberflexeucalyptust331Scale  from "../images/surfaces/variants/oberflex-eucalyptust331-2560x1440.jpg"
import oberflexfrakebariolePanel  from "../images/surfaces/variants/oberflex-frakebariole-1200x2490.jpg"
import oberflexfrakebarioleScale  from "../images/surfaces/variants/oberflex-frakebariole-2560x1440.jpg"
import oberflexfrakebariolet311Panel  from "../images/surfaces/variants/oberflex-frakebariolet311-1200x2490.jpg"
import oberflexfrakebariolet311Scale  from "../images/surfaces/variants/oberflex-frakebariolet311-2560x1440.jpg"
//import oberflexfreneclairPanel  from "../images/surfaces/variants/oberflex-freneclair-1200x2490.jpg"
//import oberflexfreneclairScale  from "../images/surfaces/variants/oberflex-freneclair-2560x1440.jpg"
import oberflexfrenefr101Panel  from "../images/surfaces/variants/oberflex-frenefr101-1200x2490.jpg"
import oberflexfrenefr101Scale  from "../images/surfaces/variants/oberflex-frenefr101-2560x1440.jpg"
import oberflexfrenefr112Panel  from "../images/surfaces/variants/oberflex-frenefr112-1200x2490.jpg"
import oberflexfrenefr112Scale  from "../images/surfaces/variants/oberflex-frenefr112-2560x1440.jpg"
//import oberflexfreneod703Panel  from "../images/surfaces/variants/oberflex-freneod703-1200x2490.jpg"
//import oberflexfreneod703Scale  from "../images/surfaces/variants/oberflex-freneod703-2560x1440.jpg"
import oberflexfreneod728Panel  from "../images/surfaces/variants/oberflex-freneod728-1200x2490.jpg"
import oberflexfreneod728Scale  from "../images/surfaces/variants/oberflex-freneod728-2560x1440.jpg"
import oberflexfreneolivierPanel  from "../images/surfaces/variants/oberflex-freneolivier-1200x2490.jpg"
import oberflexfreneolivierScale  from "../images/surfaces/variants/oberflex-freneolivier-2560x1440.jpg"
import oberflexhetreetuvePanel  from "../images/surfaces/variants/oberflex-hetreetuve-1200x2490.jpg"
import oberflexhetreetuveScale  from "../images/surfaces/variants/oberflex-hetreetuve-2560x1440.jpg"
//import oberflexhetreetuveteintepoirierPanel  from "../images/surfaces/variants/oberflex-hetreetuveteintepoirier-1200x2490.jpg"
//import oberflexhetreetuveteintepoirierScale  from "../images/surfaces/variants/oberflex-hetreetuveteintepoirier-2560x1440.jpg"
import oberflexmakoremoirePanel  from "../images/surfaces/variants/oberflex-makoremoire-1200x2490.jpg"
import oberflexmakoremoireScale  from "../images/surfaces/variants/oberflex-makoremoire-2560x1440.jpg"
import oberflexmerisierdameriquePanel  from "../images/surfaces/variants/oberflex-merisierdamerique-1200x2490.jpg"
import oberflexmerisierdameriqueScale  from "../images/surfaces/variants/oberflex-merisierdamerique-2560x1440.jpg"
import oberflexmovinguimoirePanel  from "../images/surfaces/variants/oberflex-movinguimoire-1200x2490.jpg"
import oberflexmovinguimoireScale  from "../images/surfaces/variants/oberflex-movinguimoire-2560x1440.jpg"
//import oberflexnoyerdameriquet9Panel  from "../images/surfaces/variants/oberflex-noyerdameriquet9-1200x2490.jpg"
//import oberflexnoyerdameriquet9Scale  from "../images/surfaces/variants/oberflex-noyerameriquet9-2560x1440.jpg"
import oberflexnoyerameriquet266Panel  from "../images/surfaces/variants/oberflex-noyerameriquet266-1200x2490.jpg"
import oberflexnoyerameriquet266Scale  from "../images/surfaces/variants/oberflex-noyerameriquet266-2560x1440.jpg"
import oberflexnoyerameriquet160Panel  from "../images/surfaces/variants/oberflex-noyerameriquet160-1200x2490.jpg"
import oberflexnoyerameriquet160Scale  from "../images/surfaces/variants/oberflex-noyerameriquet160-2560x1440.jpg"
import oberflexnoyerameriquet292Panel  from "../images/surfaces/variants/oberflex-noyerameriquet292-1200x2490.jpg"
import oberflexnoyerameriquet292Scale  from "../images/surfaces/variants/oberflex-noyerameriquet292-2560x1440.jpg"
import oberflexnoyergrisflanellePanel  from "../images/surfaces/variants/oberflex-noyergrisflanelle-1200x2490.jpg"
import oberflexnoyergrisflanelleScale  from "../images/surfaces/variants/oberflex-noyergrisflanelle-2560x1440.jpg"
import oberflexnoyergrispoudrePanel  from "../images/surfaces/variants/oberflex-noyergrispoudre-1200x2490.jpg"
import oberflexnoyergrispoudreScale  from "../images/surfaces/variants/oberflex-noyergrispoudre-2560x1440.jpg"
import oberflexormedameriquePanel  from "../images/surfaces/variants/oberflex-ormedamerique-1200x2490.jpg"
import oberflexormedameriqueScale  from "../images/surfaces/variants/oberflex-ormedamerique-2560x1440.jpg"
//import oberflexormedameriquet326Panel  from "../images/surfaces/variants/oberflex-ormedameriquet326-1200x2490.jpg"
//import oberflexormedameriquet326Scale  from "../images/surfaces/variants/oberflex-ormedameriquet326-2560x1440.jpg"
//import oberflexormedameriquet333Panel  from "../images/surfaces/variants/oberflex-ormedameriquet333-1200x2490.jpg"
//import oberflexormedameriquet333Scale  from "../images/surfaces/variants/oberflex-ormedameriquet333-2560x1440.jpg"
import oberflexpalissandrePanel  from "../images/surfaces/variants/oberflex-palissandre-1200x2490.jpg"
import oberflexpalissandreScale  from "../images/surfaces/variants/oberflex-palissandre-2560x1440.jpg"
//import oberflexpinPanel  from "../images/surfaces/variants/oberflex-pin-1200x2490.jpg"
//import oberflexpinScale  from "../images/surfaces/variants/oberflex-pin-2560x1440.jpg"
import oberflexpinanoeudst101Panel  from "../images/surfaces/variants/oberflex-pinanoeudst101-1200x2490.jpg"
import oberflexpinanoeudst101Scale  from "../images/surfaces/variants/oberflex-pinanoeudst101-2560x1440.jpg"
import oberflexpoiriersauvagePanel  from "../images/surfaces/variants/oberflex-poirier-1200x2490.jpg"
import oberflexpoiriersauvageScale  from "../images/surfaces/variants/oberflex-poirier-2560x1440.jpg"
import oberflexsapelliPanel  from "../images/surfaces/variants/oberflex-sapelli-1200x2490.jpg"
import oberflexsapelliScale  from "../images/surfaces/variants/oberflex-sapelli-2560x1440.jpg"
import oberflexsycomorePanel  from "../images/surfaces/variants/oberflex-sycomore-1200x2490.jpg"
import oberflexsycomoreScale  from "../images/surfaces/variants/oberflex-sycomore-2560x1440.jpg"
import oberflexteckPanel  from "../images/surfaces/variants/oberflex-teck-1200x2490.jpg"
import oberflexteckScale  from "../images/surfaces/variants/oberflex-teck-2560x1440.jpg"
import oberflextineoPanel  from "../images/surfaces/variants/oberflex-tineo-1200x2490.jpg"
import oberflextineoScale  from "../images/surfaces/variants/oberflex-tineo-2560x1440.jpg"
import oberflexwengePanel  from "../images/surfaces/variants/oberflex-wenge-1200x2490.jpg"
import oberflexwengeScale  from "../images/surfaces/variants/oberflex-wenge-2560x1440.jpg"
import oberflexwengereconstituePanel  from "../images/surfaces/variants/oberflex-wengereconstitue-1200x2490.jpg"
import oberflexwengereconstitueScale  from "../images/surfaces/variants/oberflex-wengereconstitue-2560x1440.jpg"
import oberflexzebranot13Panel  from "../images/surfaces/variants/oberflex-zebranot13-1200x2490.jpg"
import oberflexzebranot13Scale  from "../images/surfaces/variants/oberflex-zebranot13-2560x1440.jpg"
import oberflexzebranot17Panel  from "../images/surfaces/variants/oberflex-zebranot17-1200x2490.jpg"
import oberflexzebranot17Scale  from "../images/surfaces/variants/oberflex-zebranot17-2560x1440.jpg"
import oberflexzebranot3Panel  from "../images/surfaces/variants/oberflex-zebranot3-1200x2490.jpg"
import oberflexzebranot3Scale  from "../images/surfaces/variants/oberflex-zebranot3-2560x1440.jpg"
import oberflexzebranot479Panel  from "../images/surfaces/variants/oberflex-zebranot479-1200x2490.jpg"
import oberflexzebranot479Scale  from "../images/surfaces/variants/oberflex-zebranot479-2560x1440.jpg"
import oberflexzebranot6Panel  from "../images/surfaces/variants/oberflex-zebranot6-1200x2490.jpg"
import oberflexzebranot6Scale  from "../images/surfaces/variants/oberflex-zebranot6-2560x1440.jpg"
import oberflexzebranoblancpoudrePanel  from "../images/surfaces/variants/oberflex-zebranoblancpoudre-1200x2490.jpg"
import oberflexzebranoblancpoudreScale  from "../images/surfaces/variants/oberflex-zebranoblancpoudre-2560x1440.jpg"
import oberflexzebranochocolatPanel  from "../images/surfaces/variants/oberflex-zebranochocolat-1200x2490.jpg"
import oberflexzebranochocolatScale  from "../images/surfaces/variants/oberflex-zebranochocolat-2560x1440.jpg"
import oberflexzebranogriscendrePanel  from "../images/surfaces/variants/oberflex-zebranogriscendre-1200x2490.jpg"
import oberflexzebranogriscendreScale  from "../images/surfaces/variants/oberflex-zebranogriscendre-2560x1440.jpg"
import oberflexzebranogrisgaletPanel  from "../images/surfaces/variants/oberflex-zebranogrisgalet-1200x2490.jpg"
import oberflexzebranogrisgaletScale  from "../images/surfaces/variants/oberflex-zebranogrisgalet-2560x1440.jpg"
import oberflexzebranonaturelPanel  from "../images/surfaces/variants/oberflex-zebranonaturel-1200x2490.jpg"
import oberflexzebranonaturelScale  from "../images/surfaces/variants/oberflex-zebranonaturel-2560x1440.jpg"

import purepapercolorSkinArgil005Panel from "../images/surfaces/variants/purepapercolor-skin-argil-005-1200x2490.jpg"
import purepapercolorSkinAzure016Panel from "../images/surfaces/variants/purepapercolor-skin-azure-016-1200x2490.jpg"
import purepapercolorSkinBlack009Panel from "../images/surfaces/variants/purepapercolor-skin-black-009-1200x2490.jpg"
import purepapercolorSkinBurgundy012Panel from "../images/surfaces/variants/purepapercolor-skin-burgundy012-1200x2490.jpg"
import purepapercolorSkinChesnut006Panel from "../images/surfaces/variants/purepapercolor-skin-chesnut-006-1200x2490.jpg"
import purepapercolorSkinCocoa007Panel from "../images/surfaces/variants/purepapercolor-skin-cocoa-007-1200x2490.jpg"
import purepapercolorSkinCream003Panel from "../images/surfaces/variants/purepapercolor-skin-cream-003-1200x2490.jpg"
import purepapercolorSkinDarkOlive017Panel from "../images/surfaces/variants/purepapercolor-skin-dark-olive-017-1200x2490.jpg"
import purepapercolorSkinDeepSky014Panel from "../images/surfaces/variants/purepapercolor-skin-deep-sky-014-1200x2490.jpg"
import purepapercolorSkinGrey010Panel from "../images/surfaces/variants/purepapercolor-skin-grey-010-1200x2490.jpg"
import purepapercolorSkinIvory002Panel from "../images/surfaces/variants/purepapercolor-skin-ivory-002-1200x2490.jpg"
import purepapercolorSkinMastic004Panel from "../images/surfaces/variants/purepapercolor-skin-mastic-004-1200x2490.jpg"
import purepapercolorSkinPaleGreen018Panel from "../images/surfaces/variants/purepapercolor-skin-pale-green-018-1200x2490.jpg"
import purepapercolorSkinPearl011Panel from "../images/surfaces/variants/purepapercolor-skin-pearl-011-1200x2490.jpg"
import purepapercolorSkinSlate08Panel from "../images/surfaces/variants/purepapercolor-skin-slate-08-1200x2490.jpg"
import purepapercolorSkinSteelBlue015Panel from "../images/surfaces/variants/purepapercolor-skin-steel-blue-015-1200x2490.jpg"
import purepapercolorSkinVertDeGris019Panel from "../images/surfaces/variants/purepapercolor-skin-vert-de-gris-019-1200x2490.jpg"
import purepapercolorSkinWhite01Panel from "../images/surfaces/variants/purepapercolor-skin-white-01-1200x2490.jpg"

import purepapercolorSkinCamel023Panel from "../images/surfaces/variants/purepapercolor-skin-camel-023-1200x2490.jpg"
import purepapercolorSkinCognac022Panel from "../images/surfaces/variants/purepapercolor-skin-cognac-022-1200x2490.jpg"
import purepapercolorSkinDarkBlue020anel from "../images/surfaces/variants/purepapercolor-skin-dark-blue-020-1200x2490.jpg"
import purepapercolorSkinImperial021Panel from "../images/surfaces/variants/purepapercolor-skin-imperial-021-1200x2490.jpg"
import purepapercolorSkinLinen025Panel from "../images/surfaces/variants/purepapercolor-skin-linen-025-1200x2490.jpg"
import purepapercolorSkinNeutral026Panel from "../images/surfaces/variants/purepapercolor-skin-neutral-026-1200x2490.jpg"
import purepapercolorSkinPalaRosa024Panel from "../images/surfaces/variants/purepapercolor-skin-pala-rosa-024-1200x2490.jpg"


import purepapermetalBrassbrushed4042Scale from "../images/surfaces/variants/purepapermetal-skin-brass-brushed-4042-scale.jpg"
import purepapermetalBrassbrushed4042Panel from "../images/surfaces/variants/purepapermetal-skin-brass-brushed-4042-panel.jpg"

import purepapermetalBronzebrushed4045Scale from "../images/surfaces/variants/purepapermetal-skin-bronze-brushed-4045-scale.jpg"
import purepapermetalBronzebrushed4045Panel from "../images/surfaces/variants/purepapermetal-skin-bronze-brushed-4045-panel.jpg"

import purepapermetalChampagnebrushed4051Scale from "../images/surfaces/variants/purepapermetal-skin-champagne-brushed-4051-scale.jpg"
import purepapermetalChampagnebrushed4051Panel from "../images/surfaces/variants/purepapermetal-skin-champagne-brushed-4051-panel.jpg"

import purepapermetalInoxbrushed4049Scale from "../images/surfaces/variants/purepapermetal-skin-inox-brushed-4049-scale.jpg"
import purepapermetalInoxbrushed4049Panel from "../images/surfaces/variants/purepapermetal-skin-inox-brushed-4049-panel.jpg"

import purepapermetalNaturalbrushed4041Scale from "../images/surfaces/variants/purepapermetal-skin-natural-brushed-4041-scale.jpg"
import purepapermetalNaturalbrushed4041Panel from "../images/surfaces/variants/purepapermetal-skin-natural-brushed-4041-panel.jpg"

import purepapermetalBlackmillfinish724Scale from "../images/surfaces/variants/purepapermetal-skin-black-mill-finish-724-scale.jpg"
import purepapermetalBlackmillfinish724Panel from "../images/surfaces/variants/purepapermetal-skin-black-mill-finish-724-panel.jpg"

import purepapermetalCoppermillfinish722Scale from "../images/surfaces/variants/purepapermetal-skin-cooper-mill-finish-722-scale.jpg"
import purepapermetalCoppermillfinish722Panel from "../images/surfaces/variants/purepapermetal-skin-cooper-mill-finish-722-panel.jpg"

import purepapermetalTeamillfinish725Scale from "../images/surfaces/variants/purepapermetal-skin-tea-mill-finish-725-scale.jpg"
import purepapermetalTeamillfinish725Panel from "../images/surfaces/variants/purepapermetal-skin-tea-mill-finish-725-panel.jpg"

import purepapermetalTinmillfinish723Scale from "../images/surfaces/variants/purepapermetal-skin-tin-mill-finish-723-scale.jpg"
import purepapermetalTinmillfinish723Panel from "../images/surfaces/variants/purepapermetal-skin-tin-mill-finish-723-panel.jpg"

import purepapermetalGunmetalmillfinish721Scale from "../images/surfaces/variants/purepapermetal-skin-gun-metal-mill-finish-721-scale.jpg"
import purepapermetalGunmetalmillfinish721Panel from "../images/surfaces/variants/purepapermetal-skin-gun-metal-mill-finish-721-panel.jpg"


const surfaces = [
  {
    id:1001,
    title: "Chêne Aurea MT2-01",
    title_fr: "Chêne Aurea MT2-01",
    title_en: "Oak Aurea MT2-01",
    title_es: "Roble Aurea MT2-01",
    ref: "2T01VHEM",
    imageThumbnail: marotteCheneAureaMT201Panel,
    imageScale: marotteCheneAureaMT201Scale,
    imagePanel: marotteCheneAureaMT201Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 3
  },
  {
    id:1002,
    title: "Chêne Aurea MT2-03",
    title_fr: "Chêne Aurea MT2-03",
    title_en: "Oak Aurea MT2-03",
    title_es: "Roble Aurea MT2-03",
    ref: "2T03VHEM",
    imageThumbnail: marotteCheneAureaMT203Panel,
    imageScale: marotteCheneAureaMT203Scale,
    imagePanel: marotteCheneAureaMT203Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 3
  },
  {
    id:1003,
    title: "Chêne Aurea MT2-14",
    title_fr: "Chêne Aurea MT2-14",
    title_en: "Oak Aurea MT2-14",
    title_es: "Roble Aurea MT2-14",
    ref: "2T14VHEM",
    imageThumbnail: marotteCheneAureaMT214Panel,
    imageScale: marotteCheneAureaMT214Scale,
    imagePanel: marotteCheneAureaMT214Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 3
  },
  {
    id:1013,
    title: "Chêne Aurea 'Blond' MT2-15",
    title_fr: "Chêne Aurea 'Blond' MT2-15",
    title_en: "Oak Aurea 'Blond' MT2-15",
    title_es: "Roble Aurea 'Blond' MT2-15",
    ref: "2T15VHEM",
    imageThumbnail: marotteCheneAureaMT215Panel,
    imageScale: marotteCheneAureaMT215Scale,
    imagePanel: marotteCheneAureaMT215Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 2
  },
  {
    id:1004,
    title: "Chêne Aurea MT2-22",
    title_fr: "Chêne Aurea MT2-22",
    title_en: "Oak Aurea MT2-22",
    title_es: "Roble Aurea MT2-22",
    ref: "2T22VHEM",
    imageThumbnail: marotteCheneAureaMT222Panel,
    imageScale: marotteCheneAureaMT222Scale,
    imagePanel: marotteCheneAureaMT222Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 1
  },
  /*
  {
    id: 5,   //0 par default is affected to the white Pure Paper Metal (last one)
    title: "Ebène reconstitué MR 19-13",
    ref: "MR19-13",
    imageThumbnail: marotteEbenereconstitueMR1913Panel,
    imageScale: marotteEbenereconstitueMR1913Scale,
    imagePanel: marotteEbenereconstitueMR1913Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 1
  },
  */
  {
    id:1006,
    title: "Frêne Excelsior MT4-09",
    title_fr: "Frêne Excelsior MT4-09",
    title_en: "Ash Excelsior MT4-09",
    title_es: "Fresno Excelsior MT4-09",
    ref: "4T09VHEM",
    imageThumbnail: marotteFreneExcelsiorMT409Panel,
    imageScale: marotteFreneExcelsiorMT409Scale,
    imagePanel: marotteFreneExcelsiorMT409Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 2
  },
  /*
  {
    id:1007,
    title: "Frêne Excelsior MT 4-26",
    ref: "MT4-26",
    imageThumbnail: marotteFreneExcelsiorMT426Panel,
    imageScale: marotteFreneExcelsiorMT426Scale,
    imagePanel: marotteFreneExcelsiorMT426Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 2
  },
  */
  {
    id:1008,   //0 par default is affected to the white Pure Paper Metal (last one)
    title: "Lati MT 100-19",
    title_fr: "Lati MT 100-19",
    title_en: "Lati MT 100-19",
    title_es: "Lati MT 100-19",
    ref: "100T19FVHEM",
    imageThumbnail: marotteLatiMT10019Panel,
    imageScale: marotteLatiMT10019Scale,
    imagePanel: marotteLatiMT10019Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 1
  },
  {
    id:1009,
    title: "Noyer US Sepium MT 12-10",
    title_fr: "Noyer US Sepium MT 12-10",
    title_en: "Walnut US Sepium MT 12-10",
    title_es: "Nogal Americano Sepium MT12-10",
    ref: " 12T10DVHEM",
    imageThumbnail: marotteNoyerUSSepiumMT1210Panel,
    imageScale: marotteNoyerUSSepiumMT1210Scale,
    imagePanel: marotteNoyerUSSepiumMT1210Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 2
  },
  {
    id:1010,
    title: "Noyer US Sepium MT 12-22",
    title_fr: "Noyer US Sepium MT 12-22",
    title_en: "Walnut US Sepium MT 12-22",
    title_es: "Nogal Americano Sepium MT12-22",
    ref: "12T22DVHEM",
    imageThumbnail: marotteNoyerUSSepiumMT1222Panel,
    imageScale: marotteNoyerUSSepiumMT1222Scale,
    imagePanel: marotteNoyerUSSepiumMT1222Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 3
  },
  /*
  {
    id: 11,
    title: "Sapelli Boyo MT 275T17",
    ref: "MT275T17",
    imageThumbnail: marotteSapelliBoyoMT275T17Panel,
    imageScale: marotteSapelliBoyoMT275T17Scale,
    imagePanel: marotteSapelliBoyoMT275T17Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 1
  },
  */
  {
    id:1012,
    title: "Tulipier Endron MT 108-25",
    title_fr: "Tulipier Endron MT 108-25",
    title_en: "Tulip wood Endron MT 108-25",
    title_es: "Tulipier Endron MT 108-25",
    ref: "108T25DVHEM",
    imageThumbnail: marotteTulipierEndronMT10825Panel,
    imageScale: marotteTulipierEndronMT10825Scale,
    imagePanel: marotteTulipierEndronMT10825Panel,
    brandId: 2,
    typeId: 3,
    shadeId: 2
  },

/*****
  OBERFLEX SURFACES FIRST VERSION SET
  *********/

  {
id:1,
title:"Acajou d'Afrique T19",
title_fr: "Acajou d'Afrique T19",
title_en: "African Mahogany T19",
title_es: "Caoba de Africa T19",
ref: '80D19M',
imageThumbnail:oberflexacajouafriquet19Panel,
imageScale:oberflexacajouafriquet19Scale,
imagePanel:oberflexacajouafriquet19Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:2,
title:"Acajou T17",
title_fr: "Acajou T17",
title_en: "Mahogany T17",
title_es: "Caoba T17",
ref: '20D17M',
imageThumbnail:oberflexacajout17Panel,
imageScale:oberflexacajout17Scale,
imagePanel:oberflexacajout17Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:3,
title:"Acajou T19",
title_fr: "Acajou T19",
title_en: "Mahogany T19",
title_es: "Caoba T19",
ref: '20D19M',
imageThumbnail:oberflexacajout19Panel,
imageScale:oberflexacajout19Scale,
imagePanel:oberflexacajout19Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:4,
title:"Ako",
title_fr: "Ako",
title_en: "Ako",
title_es: "Ako",
ref: '54FM',
imageThumbnail:oberflexakoPanel,
imageScale:oberflexakoScale,
imagePanel:oberflexakoPanel,
brandId:1,
typeId:2,
shadeId:1
},
  {
id:5,
title:"Aniégré",
title_fr: "Aniégré",
title_en: "Anigre",
title_es: "Mukali",
ref: '14FM',
imageThumbnail:oberflexaniegrePanel,
imageScale:oberflexaniegreScale,
imagePanel:oberflexaniegrePanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:6,
title:"Aniégré T6",
title_fr: "Aniégré T6",
title_en: "Anigre T6",
title_es: "Mukali T6",
ref: '14F6M',
imageThumbnail:oberflexaniegret6Panel,
imageScale:oberflexaniegret6Scale,
imagePanel:oberflexaniegret6Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:7,
title:"Aniégré T7",
title_fr: "Aniégré T7",
title_en: "Anigre T7",
title_es: "Mukali T7",
ref: '14F7N',
imageThumbnail:oberflexaniegret7Panel,
imageScale:oberflexaniegret7Scale,
imagePanel:oberflexaniegret7Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:8,
title:"Aniégré T461",
title_fr: "Aniégré T461",
title_en: "Anigre T461",
title_es: "Mukali T461",
ref: '14F461M',
imageThumbnail:oberflexaniegret461Panel,
imageScale:oberflexaniegret461Scale,
imagePanel:oberflexaniegret461Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:9,
title:"Aulne",
title_fr: "Aulne",
title_en: "Alder",
title_es: "Aliso",
ref: '10DM',
imageThumbnail:oberflexaulnePanel,
imageScale:oberflexaulneScale,
imagePanel:oberflexaulnePanel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:15,
title:"Bambou",
ref: 'ref',
imageThumbnail:oberflexbambouPanel,
imageScale:oberflexbambouScale,
imagePanel:oberflexbambouPanel,
brandId:1,
typeId:2,
shadeId:1
},
*/
  {
id:10,
title:"Bambou fin naturel",
title_fr: "Bambou fin naturel",
title_en: "Natural fine Bamboo",
title_es: "Bambú fino natural",
ref: '79FFM',
imageThumbnail:oberflexbamboufinnaturelPanel,
imageScale:oberflexbamboufinnaturelScale,
imagePanel:oberflexbamboufinnaturelPanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:11,
title:"Bambou fin ambré",
title_fr: "Bambou fin ambré",
title_en: "Amber-coloured fine Bamboo",
title_es: "Bambú fino ambar",
ref: '79FFUM',
imageThumbnail:oberflexbamboufinambrePanel,
imageScale:oberflexbamboufinambreScale,
imagePanel:oberflexbamboufinambrePanel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:18,
title:"Bouleau canadien",
title_fr:
title_en:
title_es:
ref: 'ref',
imageThumbnail:oberflexbouleaucanadienPanel,
imageScale:oberflexbouleaucanadienScale,
imagePanel:oberflexbouleaucanadienPanel,
brandId:1,
typeId:2,
shadeId:1
},
*/
/*
  {
id:46,
title:"Châtaignier",
title_fr:
title_en:
title_es:
ref: 'ref',
imageThumbnail:oberflexchataignierPanel,
imageScale:oberflexchataignierScale,
imagePanel:oberflexchataignierPanel,
brandId:1,
typeId:2,
shadeId:2
},
*/
  {
id:12,
title:"Chêne cérusé",
title_fr: "Chêne cérusé",
title_en: "Limed Oak",
title_es: "Roble encerado",
ref: '3D160D',
imageThumbnail:oberflexchenecerusePanel,
imageScale:oberflexcheneceruseScale,
imagePanel:oberflexchenecerusePanel,
brandId:1,
typeId:2,
shadeId:1
},
/*
  {
id:48,
title:"Chêne clair",
ref: 'ref',
imageThumbnail:oberflexcheneclairPanel,
imageScale:oberflexcheneclairScale,
imagePanel:oberflexcheneclairPanel,
brandId:1,
typeId:2,
shadeId:2
},
*/
  {
id:13,
title:"Chêne naturel",
title_fr: "Chêne naturel",
title_en: "Natural Oak",
title_es: "Roble natural",
ref: 'B3FD',
imageThumbnail:oberflexchenenaturelPanel,
imageScale:oberflexchenenaturelScale,
imagePanel:oberflexchenenaturelPanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:14,
title:"Chêne T3",
title_fr: "Chêne T3",
title_en: "Oak T3",
title_es: "Roble T3",
ref: '3F3D',
imageThumbnail:oberflexchenet3Panel,
imageScale:oberflexchenet3Scale,
imagePanel:oberflexchenet3Panel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:51,
title:"Chêne T4",
ref: 'ref',
imageThumbnail:oberflexchenet4Panel,
imageScale:oberflexchenet4Scale,
imagePanel:oberflexchenet4Panel,
brandId:1,
typeId:2,
shadeId:3
},

  {
id:52,
title:"Chêne T13",
ref: 'ref',
imageThumbnail:oberflexchenet13Panel,
imageScale:oberflexchenet13Scale,
imagePanel:oberflexchenet13Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:53,
title:"Chêne astrakan blanc",
ref: 'ref',
imageThumbnail:oberflexcheneastrakanblancPanel,
imageScale:oberflexcheneastrakanblancScale,
imagePanel:oberflexcheneastrakanblancPanel,
brandId:1,
typeId:2,
shadeId:1
},
*/

  {
id:15,
title:"Chêne astrakan noir",
title_fr: "Chêne astrakan noir",
title_en: "Black Astrakhan Oak",
title_es: "Roble Astracán Negro",
ref: '991AS',
imageThumbnail:oberflexcheneastrakannoirPanel,
imageScale:oberflexcheneastrakannoirScale,
imagePanel:oberflexcheneastrakannoirPanel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:16,
title:"Chêne à noeuds",
title_fr: "Chêne à noeuds",
title_en: "Knotty Oak",
title_es: "Roble con nudos",
ref: '3NCM',
imageThumbnail:oberflexcheneanoeudsPanel,
imageScale:oberflexcheneanoeudsScale,
imagePanel:oberflexcheneanoeudsPanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:17,
title:"Chêne ardoisé T308",
title_fr: "Chêne ardoisé T308",
title_en: "Slate-grey Oak T308",
title_es: "Roble pizzarado T308",
ref: '3F308D',
imageThumbnail:oberflexcheneardoiset308Panel,
imageScale:oberflexcheneardoiset308Scale,
imagePanel:oberflexcheneardoiset308Panel,
brandId:1,
typeId:2,
shadeId:3
},
/*
  {
id:57,
title:"Chêne grisé T309",
ref: 'ref',
imageThumbnail:oberflexchenegriset309Panel,
imageScale:oberflexchenegriset309Scale,
imagePanel:oberflexchenegriset309Panel,
brandId:1,
typeId:2,
shadeId:3
},

  {
id:58,
title:"Chêne cendré T310",
ref: 'ref',
imageThumbnail:oberflexchenecendret310Panel,
imageScale:oberflexchenecendret310Scale,
imagePanel:oberflexchenecendret310Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:59,
title:"Chêne flotté T311",
ref: 'ref',
imageThumbnail:oberflexcheneflottet311Panel,
imageScale:oberflexcheneflottet311Scale,
imagePanel:oberflexcheneflottet311Panel,
brandId:1,
typeId:2,
shadeId:2
},
*/

  {
id:18,
title:"Chêne vieilli T312",
title_fr: "Chêne vieilli T312",
title_en: "Aged Oak T312",
title_es: "Roble envejecido T312",
ref: '3F312D',
imageThumbnail:oberflexchenevieillit312Panel,
imageScale:oberflexchenevieillit312Scale,
imagePanel:oberflexchenevieillit312Panel,
brandId:1,
typeId:2,
shadeId:1
},
/*
  {
id:61,
title:"Chêne sauge T326",
ref: 'ref',
imageThumbnail:oberflexchenesauget326Panel,
imageScale:oberflexchenesauget326Scale,
imagePanel:oberflexchenesauget326Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:62,
title:"Chêne gris pastel T327",
ref: 'ref',
imageThumbnail:oberflexchenegrispastelt327Panel,
imageScale:oberflexchenegrispastelt327Scale,
imagePanel:oberflexchenegrispastelt327Panel,
brandId:1,
typeId:2,
shadeId:1
},

  {
id:63,
title:"Chêne grège T328",
ref: 'ref',
imageThumbnail:oberflexchenegrèget328Panel,
imageScale:oberflexchenegrèget328Scale,
imagePanel:oberflexchenegrèget328Panel,
brandId:1,
typeId:2,
shadeId:1
},

  {
id:64,
title:"Chêne blanchi T329",
ref: 'ref',
imageThumbnail:oberflexcheneblanchit329Panel,
imageScale:oberflexcheneblanchit329Scale,
imagePanel:oberflexcheneblanchit329Panel,
brandId:1,
typeId:2,
shadeId:1
},
  {
id:65,
title:"Chêne graphite T330",
ref: 'ref',
imageThumbnail:oberflexchenegraphitet330Panel,
imageScale:oberflexchenegraphitet330Scale,
imagePanel:oberflexchenegraphitet330Panel,
brandId:1,
typeId:2,
shadeId:3
},
*/

  {
id:19,
title:"Chêne teinté Chêne des marais",
title_fr: "Chêne teinté Chêne des marais",
title_en: "Bog Oak tinted Oak",
title_es: "Roble teñido marais",
ref: '3F416D',
imageThumbnail:oberflexcheneteintechenedesmaraisPanel,
imageScale:oberflexcheneteintechenedesmaraisScale,
imagePanel:oberflexcheneteintechenedesmaraisPanel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:99, //not on line
title_fr:"Chêne teinté Wengé",
title_en:"Wenge tinted Oak",
title_es:"Roble teñido wengé",
ref: 'ref',
brandId:1,
typeId:2,
shadeId:3
},
  {
id:20,
title:"Ebène des Philippines",
title_fr: "Ebène des Philippines",
title_en: "Philippines Ebony",
title_es: "Ebano filipino",
ref: '214FN',
imageThumbnail:oberflexebènedesphilippinesPanel,
imageScale:oberflexebènedesphilippinesScale,
imagePanel:oberflexebènedesphilippinesPanel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:21,
title:"Erable canadien",
title_fr: "Erable canadien",
title_en: "Canadian Maple",
title_es: "Arce Canadiense",
ref: '50DM',
imageThumbnail:oberflexerablecanadienPanel,
imageScale:oberflexerablecanadienScale,
imagePanel:oberflexerablecanadienPanel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:70,
title:"Erable moucheté",
ref: 'ref',
imageThumbnail:oberflexerablemouchetePanel,
imageScale:oberflexerablemoucheteScale,
imagePanel:oberflexerablemouchetePanel,
brandId:1,
typeId:2,
shadeId:2
},
*/
  {
id:22,
title:"Eucalyptus",
title_fr: "Eucalyptus",
title_en: "Eucalyptus",
title_es: "Eucalipto",
ref: '137FM',
imageThumbnail:oberflexeucalyptusPanel,
imageScale:oberflexeucalyptusScale,
imagePanel:oberflexeucalyptusPanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:23,
title:"Eucalyptus T326",
title_fr: "Eucalyptus T326",
title_en: "Eucalyptus T326",
title_es: "Eucalipto T326",
ref: '137F326M',
imageThumbnail:oberflexeucalyptust326Panel,
imageScale:oberflexeucalyptust326Scale,
imagePanel:oberflexeucalyptust326Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:24,
title:"Eucalyptus T311",
title_fr: "Eucalyptus T311",
title_en: "Eucalyptus T311",
title_es: "Eucalipto T311",
ref: '137F311M',
imageThumbnail:oberflexeucalyptust311Panel,
imageScale:oberflexeucalyptust311Scale,
imagePanel:oberflexeucalyptust311Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:25,
title:"Eucalyptus T6",
title_fr: "Eucalyptus T6",
title_en: "Eucalyptus T6",
title_es: "Eucalipto T6",
ref: '137F6M',
imageThumbnail:oberflexeucalyptust6Panel,
imageScale:oberflexeucalyptust6Scale,
imagePanel:oberflexeucalyptust6Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:26,
title:"Eucalyptus T331",
title_fr: "Eucalyptus T331",
title_en: "Eucalyptus T331",
title_es: "Eucalipto T331",
ref: '137F311M',
imageThumbnail:oberflexeucalyptust331Panel,
imageScale:oberflexeucalyptust331Scale,
imagePanel:oberflexeucalyptust331Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:27,
title:"Fraké Bariolé",
title_fr: "Fraké Bariolé",
title_en: "Black Limba",
title_es: "Limba Negra",
ref: '110FM',
imageThumbnail:oberflexfrakebariolePanel,
imageScale:oberflexfrakebarioleScale,
imagePanel:oberflexfrakebariolePanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:28,
title:"Fraké Bariolé T311",
title_fr: "Fraké Bariolé T311",
title_en: "Black Limba T311",
title_es: "Limba Negra T311",
ref: '110F311M',
imageThumbnail:oberflexfrakebariolet311Panel,
imageScale:oberflexfrakebariolet311Scale,
imagePanel:oberflexfrakebariolet311Panel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:78,
title:"Frêne clair",
ref: 'ref',
imageThumbnail:oberflexfreneclairPanel,
imageScale:oberflexfreneclairScale,
imagePanel:oberflexfreneclairPanel,
brandId:1,
typeId:2,
shadeId:2
},
*/
  {
id:29,
title:"Frêne FR 101",
title_fr: "Frêne FR 101",
title_en: "Ash FR 101",
title_es: "Fresno FR 101",
ref: '5D101D',
imageThumbnail:oberflexfrenefr101Panel,
imageScale:oberflexfrenefr101Scale,
imagePanel:oberflexfrenefr101Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:30,
title:"Frêne FR 112",
title_fr: "Frêne FR 112",
title_en: "Ash FR 112",
title_es: "Fresno FR 112",
ref: '5D112D',
imageThumbnail:oberflexfrenefr112Panel,
imageScale:oberflexfrenefr112Scale,
imagePanel:oberflexfrenefr112Panel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:81,
title:"Frêne OD 703",
ref: 'ref',
imageThumbnail:oberflexfreneod703Panel,
imageScale:oberflexfreneod703Scale,
imagePanel:oberflexfreneod703Panel,
brandId:1,
typeId:2,
shadeId:3
},
*/
  {
id:31,
title:"Frêne OD 728",
title_fr: "Frêne OD 728",
title_en: "Ash OD 728",
title_es: "Fresno OD 728",
ref: '5D728D',
imageThumbnail:oberflexfreneod728Panel,
imageScale:oberflexfreneod728Scale,
imagePanel:oberflexfreneod728Panel,
brandId:1,
typeId:2,
shadeId:1
},
  {
id:32,
title:"Frêne Olivier",
title_fr: "Frêne Olivier",
title_en: "Olive Ash",
title_es: "Fresno Olivato",
ref: '218DCM',
imageThumbnail:oberflexfreneolivierPanel,
imageScale:oberflexfreneolivierScale,
imagePanel:oberflexfreneolivierPanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:33,
title:"Hêtre étuvé",
title_fr: "Hêtre étuvé",
title_en: "Steamed Beech",
title_es: "Haya vaporizada",
ref: '6FM',
imageThumbnail:oberflexhetreetuvePanel,
imageScale:oberflexhetreetuveScale,
imagePanel:oberflexhetreetuvePanel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:85,
title:"Hêtre étuvé teinté poirier",
ref: 'ref',
imageThumbnail:oberflexhetreetuveteintepoirierPanel,
imageScale:oberflexhetreetuveteintepoirierScale,
imagePanel:oberflexhetreetuveteintepoirierPanel,
brandId:1,
typeId:2,
shadeId:2
},
*/
  {
id:34,
title:"Makoré moiré",
title_fr: "Makoré moiré",
title_en: "Figured Mahogany",
title_es: "Makore reflejado",
ref: '1MM',
imageThumbnail:oberflexmakoremoirePanel,
imageScale:oberflexmakoremoireScale,
imagePanel:oberflexmakoremoirePanel,
brandId:1,
typeId:2,
shadeId:3
},

  {
id:35,
title:"Merisier d’Amérique",
title_fr: "Merisier d’Amérique",
title_en: "American Cherry",
title_es: "Cerezo americano",
ref: '181DM',
imageThumbnail:oberflexmerisierdameriquePanel,
imageScale:oberflexmerisierdameriqueScale,
imagePanel:oberflexmerisierdameriquePanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:36,
title:"Movingui moiré",
title_fr: "Movingui moiré",
title_en: "Figured Movingui",
title_es: "Movingui reflejado",
ref: '61FD',
imageThumbnail:oberflexmovinguimoirePanel,
imageScale:oberflexmovinguimoireScale,
imagePanel:oberflexmovinguimoirePanel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:89,
title:"Noyer d’Amérique T9",
ref: 'ref',
imageThumbnail:oberflexnoyerdameriquet9Panel,
imageScale:oberflexnoyerdameriquet9Scale,
imagePanel:oberflexnoyerdameriquet9Panel,
brandId:1,
typeId:2,
shadeId:3
},
*/
  {
id:37,
title:"Noyer d'Amérique T266",
title_fr: "Noyer d'Amérique T266",
title_en: "American Walnut T266",
title_es: "Nogal Americano T266",
ref: '12D266M',
imageThumbnail:oberflexnoyerameriquet266Panel,
imageScale:oberflexnoyerameriquet266Scale,
imagePanel:oberflexnoyerameriquet266Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:38,
title:"Noyer d'Amérique T160",
title_fr: "Noyer d'Amérique T160",
title_en: "American Walnut T160",
title_es: "Nogal Americano T160",
ref: '12D160M',
imageThumbnail:oberflexnoyerameriquet160Panel,
imageScale:oberflexnoyerameriquet160Scale,
imagePanel:oberflexnoyerameriquet160Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:39,
title:"Noyer d'Amérique T292",
title_fr: "Noyer d'Amérique T292",
title_en: "American Walnut T292",
title_es: "Nogal Americano T292",
ref: '12D292M',
imageThumbnail:oberflexnoyerameriquet292Panel,
imageScale:oberflexnoyerameriquet292Scale,
imagePanel:oberflexnoyerameriquet292Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:40,
title:"Noyer gris flanelle",
title_fr: "Noyer gris flanelle",
title_en: "Grey Flannel Walnut",
title_es: "Nogal gris franela",
ref: '12D304M',
imageThumbnail:oberflexnoyergrisflanellePanel,
imageScale:oberflexnoyergrisflanelleScale,
imagePanel:oberflexnoyergrisflanellePanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:41,
title:"Noyer gris poudré",
title_fr: "Noyer gris poudré",
title_en: "Grey Powdered Walnut",
title_es: "Nogal gris empolvado",
ref: '12D305M',
imageThumbnail:oberflexnoyergrispoudrePanel,
imageScale:oberflexnoyergrispoudreScale,
imagePanel:oberflexnoyergrispoudrePanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:42,
title:"Orme d’Amérique",
title_fr: "Orme d’Amérique",
title_en: "American Elm",
title_es: "Olmo Americano",
ref: '17DD',
imageThumbnail:oberflexormedameriquePanel,
imageScale:oberflexormedameriqueScale,
imagePanel:oberflexormedameriquePanel,
brandId:1,
typeId:2,
shadeId:2
},
/*
  {
id:96,
title:"Orme d'Amérique T326",
ref: 'ref',
imageThumbnail:oberflexormeameriquet326Panel,
imageScale:oberflexormeameriquet326Scale,
imagePanel:oberflexormeameriquet326Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:97,
title:"Orme d'Amérique T333",
ref: 'ref',
imageThumbnail:oberflexormeameriquet333Panel,
imageScale:oberflexormeameriquet333Scale,
imagePanel:oberflexormeameriquet333Panel,
brandId:1,
typeId:2,
shadeId:3
},
*/

  {
id:43,
title:"Palissandre",
title_fr: "Palissandre",
title_en: "Rosewood",
title_es: "Palisandro",
ref: 'R19T15DM',
imageThumbnail:oberflexpalissandrePanel,
imageScale:oberflexpalissandreScale,
imagePanel:oberflexpalissandrePanel,
brandId:1,
typeId:2,
shadeId:3
},
/*
  {
id:99,
title:"Pin",
ref: 'ref',
imageThumbnail:oberflexpinPanel,
imageScale:oberflexpinScale,
imagePanel:oberflexpinPanel,
brandId:1,
typeId:2,
shadeId:2
},
*/
  {
id:44,
title:"Pin à noeuds T101",
title_fr: "Pin à noeuds T101",
title_en: "Knotty Pine T101",
title_es: "Pino con nudos T101",
ref: '32ND101CM',
imageThumbnail:oberflexpinanoeudst101Panel,
imageScale:oberflexpinanoeudst101Scale,
imagePanel:oberflexpinanoeudst101Panel,
brandId:1,
typeId:2,
shadeId:3
},

{
id:59,
title:"Poirier sauvage",
title_fr: "Poirier sauvage",
title_en: "Wild Pear",
title_es: "Peral Salvaje",
ref: 'ref',
imageThumbnail:oberflexpoiriersauvagePanel,
imageScale:oberflexpoiriersauvageScale,
imagePanel:oberflexpoiriersauvagePanel,
brandId:1,
typeId:2,
shadeId:2
},

{
id:58,
title:"Sapelli",
title_fr: "Sapelli",
title_en: "Sapele",
title_es: "Sapelli",
ref: 'ref',
imageThumbnail:oberflexsapelliPanel,
imageScale:oberflexsapelliScale,
imagePanel:oberflexsapelliPanel,
brandId:1,
typeId:2,
shadeId:3
},

  {
id:57,
title:"Sycomore",
title_fr: "Sycomore",
title_en: "Sycamore",
title_es: "Sicomoro",
ref: 'ref',
imageThumbnail:oberflexsycomorePanel,
imageScale:oberflexsycomoreScale,
imagePanel:oberflexsycomorePanel,
brandId:1,
typeId:2,
shadeId:1
},


  {
id:61,
title:"Teck",
title_fr: "Teck",
title_en: "Teak",
title_es: "Teca",
ref: 'ref',
imageThumbnail:oberflexteckPanel,
imageScale:oberflexteckScale,
imagePanel:oberflexteckPanel,
brandId:1,
typeId:2,
shadeId:3
},



  {
id:60,
title:"Tinéo",
title_fr: "Tinéo",
title_en: "Tineo",
title_es: "Tineo",
ref: 'ref',
imageThumbnail:oberflextineoPanel,
imageScale:oberflextineoScale,
imagePanel:oberflextineoPanel,
brandId:1,
typeId:2,
shadeId:2
},

  {
id:45,
title:"Wengé",
title_fr: "Wengé",
title_en: "Wenge",
title_es: "Wengé",
ref: '26FR',
imageThumbnail:oberflexwengePanel,
imageScale:oberflexwengeScale,
imagePanel:oberflexwengePanel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:46,
title:"Wengé reconstitué",
title_fr: "Wengé reconstitué",
title_en: "Reconstitued Wenge",
title_es: "Wengé Prefabricado",
ref: 'R26FR',
imageThumbnail:oberflexwengereconstituePanel,
imageScale:oberflexwengereconstitueScale,
imagePanel:oberflexwengereconstituePanel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:47,
title:"Zébrano T13",
title_fr: "Zébrano T13",
title_en: "Zebrano T13",
title_es: "Zebrano T13",
ref: '71F13M',
imageThumbnail:oberflexzebranot13Panel,
imageScale:oberflexzebranot13Scale,
imagePanel:oberflexzebranot13Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:48,
title:"Zébrano T17",
title_fr: "Zébrano T17",
title_en: "Zebrano T17",
title_es: "Zebrano T17",
ref: '71F17M',
imageThumbnail:oberflexzebranot17Panel,
imageScale:oberflexzebranot17Scale,
imagePanel:oberflexzebranot17Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:49,
title:"Zébrano T3",
title_fr: "Zébrano T3",
title_en: "Zebrano T3",
title_es: "Zebrano T3",
ref: '71F3M',
imageThumbnail:oberflexzebranot3Panel,
imageScale:oberflexzebranot3Scale,
imagePanel:oberflexzebranot3Panel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:50,
title:"Zébrano T479",
title_fr: "Zébrano T479",
title_en: "Zebrano T479",
title_es: "Zebrano T479",
ref: '71F479M',
imageThumbnail:oberflexzebranot479Panel,
imageScale:oberflexzebranot479Scale,
imagePanel:oberflexzebranot479Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:51,
title:"Zébrano T6",
title_fr: "Zébrano T6",
title_en: "Zebrano T6",
title_es: "Zebrano T6",
ref: '71F6M',
imageThumbnail:oberflexzebranot6Panel,
imageScale:oberflexzebranot6Scale,
imagePanel:oberflexzebranot6Panel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:52,
title:"Zébrano blanc poudré",
title_fr: "Zébrano blanc poudré",
title_en: "White Powdered Zebrano",
title_es: "Zebrano blanco empolvado",
ref: 'R71BF315M',
imageThumbnail:oberflexzebranoblancpoudrePanel,
imageScale:oberflexzebranoblancpoudreScale,
imagePanel:oberflexzebranoblancpoudrePanel,
brandId:1,
typeId:2,
shadeId:1
},
  {
id:53,
title:"Zébrano chocolat",
title_fr: "Zébrano chocolat",
title_en: "Chocolate Zebrano",
title_es: "Zebrano chocolate",
ref: 'R71JF313M',
imageThumbnail:oberflexzebranochocolatPanel,
imageScale:oberflexzebranochocolatScale,
imagePanel:oberflexzebranochocolatPanel,
brandId:1,
typeId:2,
shadeId:3
},
  {
id:54,
title:"Zébrano gris cendre",
title_fr: "Zébrano gris cendre",
title_en: "Grey Ashened Zebrano",
title_es: "Zebrano gris ceniza",
ref: 'R71BF316M',
imageThumbnail:oberflexzebranogriscendrePanel,
imageScale:oberflexzebranogriscendreScale,
imagePanel:oberflexzebranogriscendrePanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:55,
title:"Zébrano gris galet",
title_fr: "Zébrano gris galet",
title_en: "Grey Pebble Zebrano",
title_es: "Zebrano gris piedra",
ref: 'R71JF317M',
imageThumbnail:oberflexzebranogrisgaletPanel,
imageScale:oberflexzebranogrisgaletScale,
imagePanel:oberflexzebranogrisgaletPanel,
brandId:1,
typeId:2,
shadeId:2
},
  {
id:56,
title:"Zébrano naturel",
title_fr: "Zébrano naturel",
title_en: "Natural Zebrano",
title_es: "Zebrano natural",
ref: '71FM',
imageThumbnail:oberflexzebranonaturelPanel,
imageScale:oberflexzebranonaturelScale,
imagePanel:oberflexzebranonaturelPanel,
brandId:1,
typeId:2,
shadeId:2
},

/*****
PURE PAPER COLOR id
*////

  {
    id:0,  // by default
    title: "Skin - White 001",
    title_fr: "Skin - White 001",
    title_en: "Skin - White 001",
    title_es: "Skin - White 001",
    ref: "001EM",
    imageThumbnail: purepapercolorSkinWhite01Panel,
    imageScale: purepapercolorSkinWhite01Panel,
    imagePanel: purepapercolorSkinWhite01Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id:2001,
    title: "Skin - Neutral Grey 026",
    title_fr: "Skin - Neutral Grey 026",
    title_en: "Skin - Neutral Grey 026",
    title_es: "Skin - Neutral Grey 026",
    ref: "026EM",
    imageThumbnail: purepapercolorSkinNeutral026Panel,
    imageScale: purepapercolorSkinNeutral026Panel,
    imagePanel: purepapercolorSkinNeutral026Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id:2002,
    title: "Skin - Pearl 011",
    title_fr: "Skin - Pearl 011",
    title_en: "Skin - Pearl 011",
    title_es: "Skin - Pearl 011",
    ref: "011EM",
    imageThumbnail: purepapercolorSkinPearl011Panel,
    imageScale: purepapercolorSkinPearl011Panel,
    imagePanel: purepapercolorSkinPearl011Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id:2003,
    title: "Skin - Grey 010",
    title_fr: "Skin - Grey 010",
    title_en: "Skin - Grey 010",
    title_es: "Skin - Grey 010",
    ref: "010EM",
    imageThumbnail: purepapercolorSkinGrey010Panel,
    imageScale: purepapercolorSkinGrey010Panel,
    imagePanel: purepapercolorSkinGrey010Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2004,
    title: "Skin - Slate 008",
    title_fr:  "Skin - Slate 008",
    title_en:  "Skin - Slate 008",
    title_es:  "Skin - Slate 008",
    ref: "008EM",
    imageThumbnail: purepapercolorSkinSlate08Panel,
    imageScale: purepapercolorSkinSlate08Panel,
    imagePanel: purepapercolorSkinSlate08Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2005,
    title: "Skin - Black 009",
    title_fr: "Skin - Black 009",
    title_en: "Skin - Black 009",
    title_es: "Skin - Black 009",
    ref: "009EM",
    imageThumbnail: purepapercolorSkinBlack009Panel,
    imageScale: purepapercolorSkinBlack009Panel,
    imagePanel: purepapercolorSkinBlack009Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2006,
    title: "Skin - Dark Blue 020",
    title_fr: "Skin - Dark Blue 020",
    title_en: "Skin - Dark Blue 020",
    title_es: "Skin - Dark Blue 020",
    ref: "020EM",
    imageThumbnail: purepapercolorSkinDarkBlue020anel,
    imageScale: purepapercolorSkinDarkBlue020anel,
    imagePanel: purepapercolorSkinDarkBlue020anel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2007,
    title: "Skin - Ivory 002",
    title_fr: "Skin - Ivory 002",
    title_en: "Skin - Ivory 002",
    title_es: "Skin - Ivory 002",
    ref: "002EM",
    imageThumbnail: purepapercolorSkinIvory002Panel,
    imageScale: purepapercolorSkinIvory002Panel,
    imagePanel: purepapercolorSkinIvory002Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id: 2008,
    title: "Skin - Linen 025",
    title_fr: "Skin - Linen 025",
    title_en: "Skin - Linen 025",
    title_es: "Skin - Linen 025",
    ref: "025EM",
    imageThumbnail: purepapercolorSkinLinen025Panel,
    imageScale: purepapercolorSkinLinen025Panel,
    imagePanel: purepapercolorSkinLinen025Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id: 2009,
    title: "Skin - Cream 003",
    title_fr: "Skin - Cream 003",
    title_en: "Skin - Cream 003",
    title_es: "Skin - Cream 003",
    ref: "003EM",
    imageThumbnail: purepapercolorSkinCream003Panel,
    imageScale: purepapercolorSkinCream003Panel,
    imagePanel: purepapercolorSkinCream003Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id: 2010,
    title: "Skin - Mastic 004",
    title_fr: "Skin - Mastic 004",
    title_en: "Skin - Mastic 004",
    title_es: "Skin - Mastic 004",
    ref: "004EM",
    imageThumbnail: purepapercolorSkinMastic004Panel,
    imageScale: purepapercolorSkinMastic004Panel,
    imagePanel: purepapercolorSkinMastic004Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2011,
    title: "Skin - Argil 005",
    title_fr: "Skin - Argil 005",
    title_en: "Skin - Argil 005",
    title_es: "Skin - Argil 005",
    ref: "005EM",
    imageThumbnail: purepapercolorSkinArgil005Panel,
    imageScale: purepapercolorSkinArgil005Panel,
    imagePanel: purepapercolorSkinArgil005Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2012,
    title: "Skin - Chestnut 006",
    title_fr: "Skin - Chestnut 006",
    title_en: "Skin - Chestnut 006",
    title_es: "Skin - Chestnut 006",
    ref: "006EM",
    imageThumbnail: purepapercolorSkinChesnut006Panel,
    imageScale: purepapercolorSkinChesnut006Panel,
    imagePanel: purepapercolorSkinChesnut006Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2013,
    title: "Skin - Cocoa 007",
    title_fr: "Skin - Cocoa 007",
    title_en: "Skin - Cocoa 007",
    title_es: "Skin - Cocoa 007",
    ref: "007EM",
    imageThumbnail: purepapercolorSkinCocoa007Panel,
    imageScale: purepapercolorSkinCocoa007Panel,
    imagePanel: purepapercolorSkinCocoa007Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2014,
    title: "Skin - Imperial 021",
    title_fr: "Skin - Imperial 021",
    title_en: "Skin - Imperial 021",
    title_es: "Skin - Imperial 021",
    ref: "021EM",
    imageThumbnail: purepapercolorSkinImperial021Panel,
    imageScale: purepapercolorSkinImperial021Panel,
    imagePanel: purepapercolorSkinImperial021Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2015,
    title: "Skin - Deep sky 014",
    title_fr: "Skin - Deep sky 014",
    title_en: "Skin - Deep sky 014",
    title_es: "Skin - Deep sky 014",
    ref: "014EM",
    imageThumbnail: purepapercolorSkinDeepSky014Panel,
    imageScale: purepapercolorSkinDeepSky014Panel,
    imagePanel: purepapercolorSkinDeepSky014Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
    },
  {
    id: 2016,
    title: "Skin - Steel blue 015",
    title_fr: "Skin - Steel blue 015",
    title_en: "Skin - Steel blue 015",
    title_es: "Skin - Steel blue 015",
    ref: "015EM",
    imageThumbnail: purepapercolorSkinSteelBlue015Panel,
    imageScale: purepapercolorSkinSteelBlue015Panel,
    imagePanel: purepapercolorSkinSteelBlue015Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2017,
    title: "Skin - Azure 016",
    title_fr: "Skin - Azure 016",
    title_en: "Skin - Azure 016",
    title_es: "Skin - Azure 016",
    ref: "016EM",
    imageThumbnail: purepapercolorSkinAzure016Panel,
    imageScale: purepapercolorSkinAzure016Panel,
    imagePanel: purepapercolorSkinAzure016Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id: 2018,
    title: "Skin - Vert de gris 019",
    title_fr: "Skin - Vert de gris 019",
    title_en: "Skin - Vert de gris 019",
    title_es: "Skin - Vert de gris 019",
   ref: "019EM",
   imageThumbnail: purepapercolorSkinVertDeGris019Panel,
   imageScale: purepapercolorSkinVertDeGris019Panel,
   imagePanel: purepapercolorSkinVertDeGris019Panel,
   brandId: 3,
   typeId: 1,
   shadeId: 2
  },
  {
    id: 2019,
    title: "Skin - Pale green 018",
    title_fr:  "Skin - Pale green 018",
    title_en:  "Skin - Pale green 018",
    title_es:  "Skin - Pale green 018",
    ref: "018EM",
    imageThumbnail: purepapercolorSkinPaleGreen018Panel,
    imageScale: purepapercolorSkinPaleGreen018Panel,
    imagePanel: purepapercolorSkinPaleGreen018Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2020,
    title: "Skin - Dark olive 017",
    title_fr:  "Skin - Dark olive 017",
    title_en:  "Skin - Dark olive 017",
    title_es:  "Skin - Dark olive 017",
    ref: "017EM",
    imageThumbnail: purepapercolorSkinDarkOlive017Panel,
    imageScale: purepapercolorSkinDarkOlive017Panel,
    imagePanel: purepapercolorSkinDarkOlive017Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },
  {
    id: 2021,
    title: "Skin - Pala Rosa 024",
    title_fr:  "Skin - Pala Rosa 024",
    title_en:  "Skin - Pala Rosa 024",
    title_es:  "Skin - Pala Rosa 024",
    ref: "024EM",
    imageThumbnail: purepapercolorSkinPalaRosa024Panel,
    imageScale: purepapercolorSkinPalaRosa024Panel,
    imagePanel: purepapercolorSkinPalaRosa024Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 1
  },
  {
    id: 2022,
    title: "Skin - Camel 023",
    title_fr: "Skin - Camel 023",
    title_en: "Skin - Camel 023",
    title_es: "Skin - Camel 023",
    ref: "023EM",
    imageThumbnail: purepapercolorSkinCamel023Panel,
    imageScale: purepapercolorSkinCamel023Panel,
    imagePanel: purepapercolorSkinCamel023Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2023,
    title: "Skin - Cognac 022",
    title_fr: "Skin - Cognac 022",
    title_en: "Skin - Cognac 022",
    title_es: "Skin - Cognac 022",
    ref: "022EM",
    imageThumbnail: purepapercolorSkinCognac022Panel,
    imageScale: purepapercolorSkinCognac022Panel,
    imagePanel: purepapercolorSkinCognac022Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 2
  },
  {
    id: 2024,
    title: "Skin - Burgundy 012",
    title_fr: "Skin - Burgundy 012",
    title_en: "Skin - Burgundy 012",
    title_es: "Skin - Burgundy 012",
    ref: "012EM",
    imageThumbnail: purepapercolorSkinBurgundy012Panel,
    imageScale: purepapercolorSkinBurgundy012Panel,
    imagePanel: purepapercolorSkinBurgundy012Panel,
    brandId: 3,
    typeId: 1,
    shadeId: 3
  },


  //PURE METAL
  {
    id:3000,
    title: "Brass brushed 4042",
    title_fr: "Brass brushed 4042",
    title_en: "Brass brushed 4042",
    title_es: "Brass brushed 4042",
    ref: "4042",
    thickness: "17,8 mm",
    imageThumbnail: purepapermetalBrassbrushed4042Panel,
    imageScale: purepapermetalBrassbrushed4042Scale,
    imagePanel: purepapermetalBrassbrushed4042Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 2
  },
  {
    id:3001,
    title: "Bronze brushed 4045",
    title_fr: "Bronze brushed 4045",
    title_en: "Bronze brushed 4045",
    title_es: "Bronze brushed 4045",
    ref: "4045",
    thickness: "17,8 mm",
    imageThumbnail: purepapermetalBronzebrushed4045Panel,
    imageScale: purepapermetalBronzebrushed4045Scale,
    imagePanel: purepapermetalBronzebrushed4045Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 2
  },
  {
    id: 3002,
    title: "Champagne brushed 4051",
    title_fr: "Champagne brushed 4051",
    title_en: "Champagne brushed 4051",
    title_es: "Champagne brushed 4051",
    ref: "4051",
    thickness: "17,8 mm",
    imageThumbnail: purepapermetalChampagnebrushed4051Panel,
    imageScale: purepapermetalChampagnebrushed4051Scale,
    imagePanel: purepapermetalChampagnebrushed4051Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 1
  },
  {
    id: 3003,
    title: "Inox brushed 4049",
    title_fr: "Inox brushed 4049",
    title_en: "Inox brushed 4049",
    title_es: "Inox brushed 4049",
    ref: "4049",
    thickness: "17,8 mm",
    imageThumbnail: purepapermetalInoxbrushed4049Panel,
    imageScale: purepapermetalInoxbrushed4049Scale,
    imagePanel: purepapermetalInoxbrushed4049Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 2
  },
  {
    id: 3004,
    title: "Natural brushed 4041",
    title_fr:  "Natural brushed 4041",
    title_en:  "Natural brushed 4041",
    title_es:  "Natural brushed 4041",
    ref: "4041",
    thickness: "17,8 mm",
    imageThumbnail: purepapermetalNaturalbrushed4041Panel,
    imageScale: purepapermetalNaturalbrushed4041Scale,
    imagePanel: purepapermetalNaturalbrushed4041Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 1
  },
  {
    id: 3005,
    title: "Black mill finish 724",
    title_fr: "Black mill finish 724",
    title_en: "Black mill finish 724",
    title_es: "Black mill finish 724",
    ref: "724",
    thickness: "18,2 mm",
    imageThumbnail: purepapermetalBlackmillfinish724Panel,
    imageScale: purepapermetalBlackmillfinish724Scale,
    imagePanel: purepapermetalBlackmillfinish724Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 3
  },
  {
    id: 3006,
    title: "Copper mill finish 722",
    title_fr: "Copper mill finish 722",
    title_en: "Copper mill finish 722",
    title_es: "Copper mill finish 722",
    ref: "722",
    thickness: "18,2 mm",
    imageThumbnail: purepapermetalCoppermillfinish722Panel,
    imageScale: purepapermetalCoppermillfinish722Scale,
    imagePanel: purepapermetalCoppermillfinish722Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 2
  },
  {
    id: 3007,
    title: "Tea mill finish 725",
    title_fr: "Tea mill finish 725",
    title_en: "Tea mill finish 725",
    title_es: "Tea mill finish 725",
    ref: "725",
    thickness: "18,2 mm",
    imageThumbnail: purepapermetalTeamillfinish725Panel,
    imageScale: purepapermetalTeamillfinish725Scale,
    imagePanel: purepapermetalTeamillfinish725Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 2
  },
  {
    id: 3008,
    title: "Tin mill finish 723",
    title_fr: "Tin mill finish 723",
    title_en: "Tin mill finish 723",
    title_es: "Tin mill finish 723",
    ref: "723",
    thickness: "18,2 mm",
    imageThumbnail: purepapermetalTinmillfinish723Panel,
    imageScale: purepapermetalTinmillfinish723Scale,
    imagePanel: purepapermetalTinmillfinish723Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 2
  },
  {
    id: 3009,
    title: "Gun metal mill finish 721",
    title_fr: "Gun metal mill finish 721",
    title_en: "Gun metal mill finish 721",
    title_es: "Gun metal mill finish 721",
    ref: "721",
    thickness: "18,2 mm",
    imageThumbnail: purepapermetalGunmetalmillfinish721Panel,
    imageScale: purepapermetalGunmetalmillfinish721Scale,
    imagePanel: purepapermetalGunmetalmillfinish721Panel,
    brandId: 4,
    typeId: 4,
    shadeId: 3
  }



/*

LAST id: 131
*/
]

export const surfacesByIds = surfaces.reduce((acc, surface) => {
  acc[surface.id] = surface
  return acc
}, {})

export default surfaces



// WEBPACK FOOTER //
// ./src/constants/surfaces.js